module.exports = __webpack_public_path__ + "static/media/logo.adef1fa8.png";